// extracted by mini-css-extract-plugin
export var bio = "Bylines-module--bio--dc6e8";
export var container = "Bylines-module--container--42fd2";
export var institution = "Bylines-module--institution--87f7f";
export var name = "Bylines-module--name--f4799";
export var person = "Bylines-module--person--2a910";